<div class="load-payment">
  <div [class.rotating]="inProgress"></div>
  @if (errorMessage) {
  <p class="load-payment-error" [innerHTML]="errorMessage | cxTranslate"></p>
  }
</div>
